<script setup>

import { ref, inject, provide } from 'vue';

import Listbox from 'primevue/listbox';
import ModaleAjoutListeValeurs from './ModaleAjoutListeValeurs.vue';

const { listesValeurs } = defineProps({
	listesValeurs: Array
});

const selectionSchema = inject('selectionSchema');

const affichageModaleAjoutListeValeurs = ref(false);

function ajouterListeValeurs() {
	affichageModaleAjoutListeValeurs.value = true;
}

provide('affichageModaleAjoutListeValeurs', affichageModaleAjoutListeValeurs);

</script>

<template>
	<div>
		<div class="entete">
			<label class="titre">Listes de valeurs</label>
			<div class="conteneur-boutons">
				<button class="bouton fa-solid fa-plus" @click="ajouterListeValeurs()" />
			</div>
		</div>
		<Listbox class="liste-listes-valeurs" 
		  v-model="selectionSchema.listeValeurs" 
		  :options="listesValeurs"
		  :selectOnFocus="true"
		  :emptyMessage="'Aucune liste de valeurs'"
		  :optionLabel="'nom'"
		  :disabled="!listesValeurs.length">
		</Listbox>
		<ModaleAjoutListeValeurs />
	</div>
</template>

<style scoped>

.liste-listes-valeurs {
	height: 15vh !important;
	overflow: auto;
}

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2px;
}

</style>